
import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import { Postdata } from '../../../API/GlobalApi.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import Notifier from '../../../Utils/notify.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import { formatDateDDMMYYYYHHMMSS, formatDateDDMMYYYYHHMMSS_UTC } from '../../../Utils/data&dateTime.js';
import { RemittanceShortDetails } from './RemittanceShortDetails.js';
import OtpModal from '../../../Component/Modals/DiscountOtpInput.js';
import { useHasPermission } from '../../../Utils/checkPermissions.js';
import Session from '../../../Utils/Sessions.js';
import { handlePrintReceipt, handlePrintRemitanceReceipt } from '../../../Utils/PrintTransactionReceiptien.js';
import { highlightMatch } from '../../../Utils/highlightSearchFunctions.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';

const RemittanceTransactions = ({ handleRowClick, formattedData, isLoading, selectedTxnDetails, handlePageChange, currentPage, isSearchLoading, pageCounts, filterLoading, getTransactions, setselectedTxnForReconcile, setShowTransferReconcileModals, handleResendOtp, pageLoading, filterQueryString, tableLoading, showSpinner }) => {


    const handelReconcile = (row) => {

        setselectedTxnForReconcile(row);
        setShowTransferReconcileModals(true)
    }



    const searchValue = new URLSearchParams(filterQueryString).get("search") || "";

    const hasPermission = useHasPermission()



    const printWithStatus = async (row) => {
        try {
            const data = row.original;

            const payload = {
                transaction_id: data?.transaction_details?.transaction_id,
                student_id: data?.transfered_from?.id
            };

            // Call POST API here
            const res = await Postdata("finance/scheduled-fee-payment-status/", payload);

            // Optional notification
            // if (res?.message) {
            //     Notifier.success(res.message);
            // }
            if (res?.error) {
                Notifier.error(res.error);
                return;
            }
            // Pass row + POS status data to print function
            handlePrintRemitanceReceipt(row, res);

        } catch (error) {
            console.error("Error fetching remittance status:", error);
            Notifier.error("Failed to fetch remittance status.");
        }
    };


    const loggedInUserName = Session.get('full_name')


    const columns = useMemo(
        () => [

            {
                Header: "Remitance ID",
                accessor: 'remitance_number',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        // onClick={() => {
                        //   navigate(`/studentDashboard/StudentFullProfile/${row.original.id}`);
                        // }}
                        onClick={() => handleRowClick(row.original.id, row)}
                    >

                        <p
                            style={{
                                textAlign: "left",
                                color: "#222F3E",
                                fontWeight: 500,
                                margin: 0,
                            }}
                            dangerouslySetInnerHTML={{
                                __html: highlightMatch(
                                    row.original.remitance_number?.toString() || "-",
                                    searchValue
                                ),
                            }}
                        />

                    </div>
                ),
            },


            {
                Header: 'Remitance Date',
                accessor: 'created_at',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor" >
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{formatDateDDMMYYYYHHMMSS_UTC(row?.original.created_at)}</p>
                    </div>
                )
            },
            {
                Header: "Remiter's Name",
                accessor: 'transfered_from',
                disableSortBy: true,
                Cell: ({ row }) => {

                    return (
                        <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row?.original?.transfered_from?.name}</p>
                            {row?.original?.transfered_from?.registration_number && (
                                <p className='forcedCursor'
                                    style={{
                                        textAlign: "left",
                                        color: "#222F3E",
                                        margin: 0,
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigator.clipboard.writeText(
                                            row.original.transfered_from.registration_number
                                        );
                                        Notifier.info("Registration number copied!");
                                    }}


                                    title="Click to copy"
                                >
                                    {row.original.transfered_from.registration_number}
                                </p>
                            )}


                        </div>
                    );
                }
            },
            {
                Header: 'Contacts',
                accessor: 'contacts',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor" >
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                            {row.original?.transfered_from?.mobile}</p>
                    </div>
                )
            },
            {
                Header: 'Instrument Type',
                accessor: 'instrument',
                disableSortBy: true,
                Cell: ({ row }) => {


                    return (
                        <div className="no-text-cursor">
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                                {row?.original.instrument}
                            </p>
                        </div>
                    );
                }
            },
            {
                Header: 'Status',
                accessor: 'status',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const status = row.original?.status;
                    // Define colors for each status
                    const statusColors = {
                        Received: { bg: "#E6F7EC", color: "#1E7E34" },
                        Transferred: { bg: "#E6F0FF", color: "#1D4ED8" },
                        Success: { bg: "#F3E8FF", color: "#7C3AED" },
                        Deposited: { bg: "#FFF7E6", color: "#D97706" },
                        Reject: { bg: "#FDE2E2", color: "#B91C1C" },
                        "Re-present": { bg: "#F3F4F6", color: "#374151" },
                    };

                    // Use the status color safely
                    const { bg, color } = statusColors[status] || { bg: "#F3F4F6", color: "#374151" };


                    return (
                        <div style={{ textAlign: 'left', margin: 0 }} className="no-text-cursor">
                            <span
                                style={{
                                    display: "inline-block",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    backgroundColor: bg,
                                    color: color,
                                    textTransform: "capitalize",
                                }}
                            >
                                {status}
                            </span>
                        </div>
                    );
                }
            },
            , {

                Header: () => <p style={{ textAlign: 'right' }}>Amount</p>,
                accessor: 'amount',
                disableSortBy: true,
                Cell: ({ row }) => {

                    return (
                        <div style={{ textAlign: 'right', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                            <p style={{ textAlign: 'right', color: '#222F3E', margin: 0 }}>{row?.original.amount.toFixed(2)}</p>
                        </div>
                    );
                }
            },

            {
                Header: () => (
                    <div style={{ textAlign: "center", width: "100%" }}>Action</div>
                ),
                accessor: "action",
                disableSortBy: true,
                Cell: ({ row }) => {
                    const { status, type, verified } = row.original;
                    const fullName = Session.get("full_name")?.trim().toLowerCase();
                    const transferedFrom = row?.original?.transfered_from?.name?.trim().toLowerCase();

                    return (
                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                                justifyContent: "end",
                                alignItems: "center",
                            }}

                        >
                            {/* ✅ Reconcile icon → only when status is Deposited */}
                            {type === "deposit" && status !== "Success" && hasPermission("can-reconcile-payments") && (
                                <>
                                    {/* Case 1: Different user → cash reconcile */}
                                    {transferedFrom !== fullName && (
                                        <span
                                            role="button"
                                            tabIndex={0}
                                            className="form-check form-switch custom-switch"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Click to reconcile payment"
                                            onClick={() => handelReconcile(row.original)}
                                            style={{
                                                cursor: "pointer",
                                                padding: 6,
                                                borderRadius: 6,
                                                lineHeight: 0,
                                            }}
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                style={{ color: "#7F56DA" }}
                                            >
                                                <circle cx="12" cy="12" r="10" />
                                                <text
                                                    x="7"
                                                    y="17"
                                                    fontSize="14"
                                                    fontFamily="Arial"
                                                    fill="currentColor"
                                                >
                                                    ₹
                                                </text>
                                                <path d="M12 8v8M9 11l3-3 3 3" />
                                            </svg>
                                        </span>
                                    )}

                                    {/* Case 2: Same user → self reconcile */}
                                    {transferedFrom === fullName && hasPermission("can-reconcile-self-payments") && (
                                        <span
                                            role="button"
                                            tabIndex={0}
                                            className="form-check form-switch custom-switch"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Click to reconcile payment"
                                            onClick={() => handelReconcile(row.original)}
                                            style={{
                                                cursor: "pointer",
                                                padding: 6,
                                                borderRadius: 6,
                                                lineHeight: 0,
                                            }}
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                style={{ color: "#7F56DA" }}
                                            >
                                                <circle cx="12" cy="12" r="10" />
                                                <text
                                                    x="7"
                                                    y="17"
                                                    fontSize="14"
                                                    fontFamily="Arial"
                                                    fill="currentColor"
                                                >
                                                    ₹
                                                </text>
                                                <path d="M12 8v8M9 11l3-3 3 3" />
                                            </svg>
                                        </span>
                                    )}
                                </>
                            )}

                            {type === "transfer" && verified === false && (
                                <>
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        title="Resend OTP"
                                        onClick={() => handleResendOtp(row.original)}
                                        style={{
                                            cursor: 'pointer',
                                            padding: 6,
                                            borderRadius: 6,
                                            lineHeight: 0
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            width="24"
                                            height="24"
                                            fill="#7F56DA"
                                        >
                                            <path d="M458.5 112H265V62.4A31.4 31.4 0 0 0 233.6 31H62.4A31.4 31.4 0 0 0 31 62.4v387.2A31.4 31.4 0 0 0 62.4 481h171.2A31.4 31.4 0 0 0 265 449.6V292h193.5A22.5 22.5 0 0 0 481 269.5V134.5A22.5 22.5 0 0 0 458.5 112ZM125.5 50.1h45a11.3 11.3 0 0 1 0 22.5h-45a11.3 11.3 0 0 1 0-22.5Zm45 411.8h-45a11.3 11.3 0 1 1 0-22.5h45a11.3 11.3 0 0 1 0 22.5Zm74.7-41.6H50.8V91.8h194.4V112H125.3a22.3 22.3 0 0 0-22.3 22.3V269.7a22.3 22.3 0 0 0 22.3 22.3H166v36.1a11.1 11.1 0 0 0 19 7.9L229 292h16.2ZM220.8 210.2a11.3 11.3 0 0 1-11.3 19.5L195.3 221.4V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4L161.5 202l-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM328.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM436.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3Z" />
                                        </svg>
                                    </span>
                                    {/* <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#EF4444"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            // handelAdmissionClose(row.original.id, row);
                                        }}
                                        data-tooltip-id="admission-tip"
                                        data-tooltip-content="Cancel Admission"
                                    ><title>Cancel Transfer Request</title>
                                        <circle cx="12" cy="12" r="10" />
                                        <line x1="15" y1="9" x2="9" y2="15" />
                                        <line x1="9" y1="9" x2="15" y2="15" />
                                    </svg> */}


                                </>
                            )}


                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#7F56DA"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ cursor: 'pointer' }}
                                onClick={() => printWithStatus(row)}
                                data-tooltip-id="admission-tip"
                                data-tooltip-content="Print Receiving"
                            >
                                <path d="M6 9V2h12v7" />
                                <path d="M6 18H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2" />
                                <rect x="6" y="14" width="12" height="8" />
                                <title>Print Receiving</title>
                            </svg>
                        </div>
                    );
                },
            }

            ,
        ],
        [loggedInUserName, hasPermission, searchValue]
    );




  return (
    <>
        {isLoading ? (
            <SpinnerLoader />
        ) : (
            <div style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
            }}>
                {(filterLoading || showSpinner) ? (
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                    }}>
                        <SpinnerLoader />
                    </div>
                ) : formattedData?.length > 0 ? (
                    <AdvanceTable
                        columns={columns}
                        pageCounts={pageCounts}
                        handlePageChange={handlePageChange}
                        selectedData={selectedTxnDetails}
                        data={formattedData}
                        handleRowClick={handleRowClick}
                        currentPage={currentPage}
                        checkbox={false}
                        rowClassName="small-row"
                    />
                ) : (!isLoading && !isSearchLoading && (
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                        color: "#888",
                        textAlign: "center",
                        fontSize: "1.1rem",
                        fontWeight: 500,
                    }}>
                        No Remittances available.
                    </div>
                ))}
            </div>
        )}
    </>
);
};


export default RemittanceTransactions